import { HIGHLIGHT_SELECTION_HINT_ATTRIBUTE_NAME, HighlightSelectionHint } from '../Highlight/types';

export const getHighlightSelectionTipProps = (highlightSelectionTip: HighlightSelectionHint) => ({
  [HIGHLIGHT_SELECTION_HINT_ATTRIBUTE_NAME]: highlightSelectionTip,
});
